import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ar from './locales/ar'
import en from './locales/en'
import de from './locales/de'
import fr from './locales/fr'
import ja from './locales/ja'
import nl from './locales/nl'
import zhCn from './locales/zh-cn'
import zhTw from './locales/zh-tw'
import es from './locales/es'

Vue.use(VueI18n)

const messages = {
  ar,
  en,
  de,
  fr,
  ja,
  nl,
  'zh-cn': zhCn,
  'zh-tw': zhTw,
  es
}
const i18n = new VueI18n({
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
})

export default i18n
